<script setup>
// eslint-disable-next-line no-undef
const props = defineProps({
  comment: {type: Object, required: true}
});
</script>

<template>
  <!-- A single label is shown by name, tinted with its own colour: Vuetify writes a
       CSS colour straight to the inline text colour, which the tonal underlay picks up. -->
  <v-chip v-if="props.comment.hasSingleLabel()"
          class="issue-label-chip"
          size="small"
          variant="tonal"
          :color="props.comment.labels[0].color"
          prepend-icon="mdi-tag-outline"
          @click.stop
  >
    {{ props.comment.labels[0].name }}
  </v-chip>

  <!-- Several labels collapse into a count, listed in a scrollable menu. -->
  <v-chip v-else-if="props.comment.hasLabels()"
          class="issue-label-chip"
          size="small"
          variant="tonal"
          prepend-icon="mdi-tag-multiple-outline"
          append-icon="mdi-menu-down"
          @click.stop
  >
    {{ props.comment.getLabelCount() }} {{ $t('label', props.comment.getLabelCount()) }}
    <v-menu activator="parent">
      <v-list class="issue-labels-menu" density="compact">
        <v-list-subheader>{{ $t('comments.labels.title') }}</v-list-subheader>
        <v-list-item v-for="label in props.comment.labels"
                     :key="label.id"
        >
          <template v-slot:prepend>
            <span class="issue-label-dot"
                  :style="{ backgroundColor: label.color }"
            ></span>
          </template>
          <v-list-item-title>{{ label.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-chip>
</template>

<style scoped>
.issue-label-chip {
  flex-shrink: 0;
}

.issue-labels-menu {
  min-width: 180px;
  max-height: 240px; /* long label lists scroll instead of overflowing the panel */
  overflow-y: auto;
}

.issue-label-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}
</style>
